import React, { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Terminal from './components/Terminal';
import Projects from './components/Projects';
import Footer from './components/Footer';
import projects from './content/projects';
import Contact from './components/Contact';
import ResumeGateModal from './components/ResumeGateModal';

import './scss/index.scss';

function App() {
  const [isResumeModalOpen, setIsResumeModalOpen] = useState(false);

  const handleOpenResumeModal = () => setIsResumeModalOpen(true);
  const handleCloseResumeModal = () => setIsResumeModalOpen(false);

  return (
    <div className="App">
      <Navbar onOpenResumeModal={handleOpenResumeModal} />
      <Hero />
      <Terminal onOpenResumeModal={handleOpenResumeModal} />
      <h2 id="projects" className="section-title" tabIndex="-1">
        Projects
      </h2>
      <Projects projects={projects} />
      <h2 id="contact" className="section-title" tabIndex="-1">
          Contact
      </h2>
      <Contact />
      <Footer />
      <ResumeGateModal
        isOpen={isResumeModalOpen}
        onClose={handleCloseResumeModal}
      />
    </div>
  );
}

export default App;
